import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Bill Merritt",
        title: "Founder & CEO",
        biography: "Bill Merritt is the visionary Founder & CEO of our travel agency. With a profound passion for exploration and innovation, he has built the company into a leading name in the travel and adventure industry. Bill’s leadership ensures that every journey is crafted to deliver exceptional experiences to travelers worldwide.",
        contacts: {
            experience: "15 years",
            phone: "222-333-4455",
            email: "bill.merritt@example.com",
            website: "www.billmerrittadventures.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Business Development Strategist",
            "Adventure Tour Planner",
            "Leadership & Team Mentor",
            "Customer Experience Innovator",
            "Sustainable Travel Advocate"
        ],
        specialties: [
            { id: 1, title: "Business Strategy", progress: 95 },
            { id: 2, title: "Adventure Tour Design", progress: 90 },
            { id: 3, title: "Leadership & Management", progress: 92 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Karen Marsh",
        title: "Manager",
        biography: "Karen Marsh is the operational backbone of our travel agency, serving as the Manager with a keen focus on seamless logistics and client satisfaction. With her expertise in team coordination and itinerary planning, she ensures that every journey is executed with precision and care.",
        contacts: {
            experience: "12 years",
            phone: "333-444-5566",
            email: "karen.marsh@example.com",
            website: "www.karenmarshtravels.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Operations and Logistics Expert",
            "Client Relationship Manager",
            "Custom Itinerary Planner",
            "Team Coordination Specialist",
            "Quality Assurance Supervisor"
        ],
        specialties: [
            { id: 1, title: "Operations Management", progress: 93 },
            { id: 2, title: "Client Relations", progress: 90 },
            { id: 3, title: "Itinerary Planning", progress: 88 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Jack Newman",
        title: "Tour Guide",
        biography: "Jack Newman is a passionate Tour Guide known for his engaging storytelling and deep knowledge of cultural and natural landmarks. With a friendly approach and dedication to creating memorable experiences, Jack ensures every tour is informative, safe, and enjoyable for travelers of all ages.",
        contacts: {
            experience: "8 years",
            phone: "444-555-6677",
            email: "jack.newman@example.com",
            website: "www.jacktourspecialist.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Certified Cultural Tour Guide",
            "Local History & Heritage Expert",
            "Multilingual Group Leader",
            "Safety & First Aid Trained",
            "Interactive Storytelling Specialist"
        ],
        specialties: [
            { id: 1, title: "Cultural Tours", progress: 90 },
            { id: 2, title: "Storytelling", progress: 95 },
            { id: 3, title: "Group Leadership", progress: 88 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Sue Brown",
        title: "Tour Guide",
        biography: "Sue Brown is an enthusiastic Tour Guide with a love for sharing hidden gems and unique cultural insights with travelers. Known for her friendly demeanor and expert navigation skills, Sue ensures every tour is a personalized and unforgettable experience for her guests.",
        contacts: {
            experience: "7 years",
            phone: "555-666-7788",
            email: "sue.brown@example.com",
            website: "www.suebrowntravels.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "City Sightseeing Specialist",
            "Cultural & Culinary Tour Guide",
            "Local Market Exploration Expert",
            "Guest Engagement & Experience Enhancer",
            "Emergency Response Trained"
        ],
        specialties: [
            { id: 1, title: "City Tours", progress: 92 },
            { id: 2, title: "Guest Engagement", progress: 90 },
            { id: 3, title: "Navigation & Safety", progress: 87 }
        ]
    }

];

export default team;